// ══════════════════════════════════════════════════════════════════
//  bluehub — fachada do consumo da API do Hub (api-bluehub)
//
//  A X-API-Key não existe deste lado: toda chamada vai para /api/bluehub,
//  a rota do nosso servidor (server/bluehub/), que a lê do env e assina a
//  operação com o usuário da sessão como X-Actor-Id.
//
//  Contrato:  api-bluehub/interna/API-INTERNA.md (repo vizinho). A cópia local
//             docs/API-INTERNA-Bluehub.md é histórica — sem definir-avatar,
//             sem `modelo`, sem o alcance de 16/09.
//  Plano:     docs/plano_integracao_hub_crm_write.md
//
//  ⚠️ O `empresaPublicId` ainda é passado pela chamada. Quando existir a
//  tabela de vínculo (`cs.hub_contas`, Fase 1 do plano), ele passa a ser
//  resolvido no servidor a partir do `empresaId`, e some daqui.
// ══════════════════════════════════════════════════════════════════

import { bluehubService } from './core';

export const criarEmpresaNoHub = bluehubService.criarEmpresa;
export const atualizarEmpresaNoHub = bluehubService.atualizarEmpresa;
export const listarPlanosDoHub = bluehubService.listarPlanos;
export const provisionarVidasNoHub = bluehubService.provisionarVidas;
export const convidarVidasNoHub = bluehubService.convidarVidas;
export const enviarContratoPeloHub = bluehubService.enviarContrato;
export const emitirCobrancaNoHub = bluehubService.emitirCobranca;
export const solicitarAcessoNoHub = bluehubService.solicitarAcesso;
export const lerVidasDaEmpresaNoHub = bluehubService.lerVidasDaEmpresa;
export const lerCobrancasDaEmpresaNoHub = bluehubService.lerCobrancasDaEmpresa;
// Relê TODAS as empresas do Hub — o botão "Atualizar agora" de /clientes
// (aba Hub). Sem empresaId: não é uma operação por empresa.
export const sincronizarEmpresasHub = bluehubService.sincronizarEmpresas;

export {
  vagasAProvisionar, podeFecharVenda, slugsForaDoCatalogo, explicarFalha,
  lerDesfechoCobranca, emailDoBoletoSaiu, atingiuOPiso, PISO_VIDAS_FATURAVEIS,
} from '@modules/bluehub';

export { BluehubGatewayError } from '@infra/http/BluehubApiClient';

export type {
  BluehubMarca, BluehubQualificacao, BluehubEndereco, BluehubRepresentante,
  BluehubNovaEmpresa, BluehubCorrecaoEmpresa, BluehubEmpresaCriada,
  BluehubEmpresaAtualizada, BluehubCampoAlterado, BluehubPlano, BluehubPlanos,
  BluehubItemVidas, BluehubVidasProvisionadas, BluehubPessoaConvidada,
  BluehubConvite, BluehubConvites, BluehubNotificacaoEmail,
  BluehubCobranca, BluehubSituacaoCobranca, BluehubContrato, BluehubAcesso,
  BluehubFalha, BluehubCodigoErro, BluehubDicaConflito, BluehubIdempotencia,
  BluehubSincronizacaoEmpresas,
  DesfechoCobranca, AcaoPosCobranca,
} from '@modules/bluehub';
